module.exports = __webpack_public_path__ + "img/billboard-preview.a87faa53.png";